<template>
  <div>
    <Dialogs />
    <SystemConfigPage v-if="$route.path == '/console/system-config'" />
    <AnnouncementEditorPage v-if="$route.path == '/announcement/edit'" />
    <QQGroupListPage v-if="$route.path == '/console/misc/qqgroups'"/>
    <SpeakerTaskListPage v-if="$route.path == '/speaker'" />
    <ZoneListPage v-if="$route.path == '/zone/list'" />
    <MailTemplateListPage v-if="$route.path == '/mail/templateList'" />
    <AdminUserListPage v-if="$route.path == '/adminUser/list'" />
    <FunctionSwitchListPage v-if="$route.path == '/function-switch/list'"/>
    <VersionTabPanelPage v-if="$route.path == '/console/version'" />
  </div>
</template>

<script>
import Dialogs from "@/dialogs/Dialogs";
import SystemConfigPage from "@/pages/system-config/SystemConfigPage";
import ZoneListPage from "@/pages/zone/ZoneListPage";
import AnnouncementEditorPage from "@/pages/announcement/AnnouncementEditorPage";
import QQGroupListPage from "@/pages/qqGroup/QQGroupListPage";
import MailTemplateListPage from "@/pages/mail/MailTemplateListPage";
import SpeakerTaskListPage from "@/pages/speaker/SpeakerTaskListPage";
import AdminUserListPage from "@/pages/adminUser/AdminUserListPage";
import FunctionSwitchListPage from "@/pages/function-switch/FunctionSwitchListPage";
import VersionTabPanelPage from "@/pages/version/VersionTabPanelPage";

export default {
  data() {
    return {};
  },

  components: {
    Dialogs,
    SystemConfigPage,
    ZoneListPage,
    AnnouncementEditorPage,
    QQGroupListPage,
    MailTemplateListPage,
    SpeakerTaskListPage,
    AdminUserListPage,
    FunctionSwitchListPage,
    VersionTabPanelPage,
  },

  methods: {},
};
</script>

<style scoped>
</style>